import { SUBJECT_STYLE } from "./activityStyle";

/** Atom: işlemin yapıldığı kayıt — cihaz seri no / firma / kullanıcı (#412) */
export default function SubjectChip({ subject, className = "" }) {
  if (!subject?.label) return null;
  const style = SUBJECT_STYLE[subject.kind];
  if (!style) return null;
  const Icon = style.icon;
  return (
    <span className={`inline-flex min-w-0 items-center gap-1 rounded-md px-1.5 py-0.5 font-Medium ${style.tone} ${className}`}>
      <Icon className="h-3 w-3 shrink-0" />
      <span className="truncate">{subject.label}</span>
    </span>
  );
}
